import React from 'react'
import { NavItem } from 'reactstrap'
import PropTypes from 'prop-types'

export function ResourceCenterNavItem (props) {
  return (
    <NavItem>
      <div id='resource-centre' className='nav-link'>
        <mosaic-icon name='info' />
        <div className='d-none d-xl-block'>Resource centre</div>
      </div>
    </NavItem>
  )
}

ResourceCenterNavItem.propTypes = {
  url: PropTypes.object
}
